"use client";

import { c as _c } from "react/compiler-runtime";
import { AppRouterCacheProvider } from "@mui/material-nextjs/v16-appRouter";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/next";
import React, { type ReactNode } from "react";
import "symbol-observable";
import { CookieConsentRoot } from "#/features/cookieConsent/ui/CookieConsentRoot";
import { type I18nProps } from "#/i18n/getI18nProps";
import type { Locales } from "#/i18n/i18n-types";
import { AppShellProviders } from "#/shared/ui/providers/AppShellProviders";
import { I18nProvider } from "#/shared/ui/providers/I18nProvider";
import type { SsrDeviceType } from "#/themes";
import { RuntimeDeviceHintProvider } from "#/app/locale-app/RuntimeDeviceHintContext";
type AppRootLayoutClientProps = {
  children: ReactNode;
  i18n: I18nProps;
  locale: Locales;
  ssrDeviceType?: SsrDeviceType;
};

/**
 * App Router provider shell (locale i18n + device hint stay outside SessionGate).
 */
export const AppRootLayoutClient: React.FC<AppRootLayoutClientProps> = t0 => {
  const $ = _c(15);
  const {
    children,
    i18n,
    locale,
    ssrDeviceType: t1
  } = t0;
  const ssrDeviceType = t1 === undefined ? "desktop" : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      key: "css"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Analytics />;
    t4 = <SpeedInsights />;
    $[1] = t3;
    $[2] = t4;
  } else {
    t3 = $[1];
    t4 = $[2];
  }
  let t5;
  if ($[3] !== children) {
    t5 = <CookieConsentRoot>{children}{t3}{t4}</CookieConsentRoot>;
    $[3] = children;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== i18n || $[6] !== locale || $[7] !== t5) {
    t6 = <I18nProvider locale={locale} i18n={i18n}>{t5}</I18nProvider>;
    $[5] = i18n;
    $[6] = locale;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== ssrDeviceType || $[10] !== t6) {
    t7 = <AppShellProviders ssrDeviceType={ssrDeviceType}>{t6}</AppShellProviders>;
    $[9] = ssrDeviceType;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== ssrDeviceType || $[13] !== t7) {
    t8 = <AppRouterCacheProvider options={t2}><RuntimeDeviceHintProvider initialSsrDeviceType={ssrDeviceType}>{t7}</RuntimeDeviceHintProvider></AppRouterCacheProvider>;
    $[12] = ssrDeviceType;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
};